import FormLayout from '../components/layouts/formPage/FormLayout';
import SignupForm from '../components/signup/SignupForm';

const SignUp = () => {
  return (
    <FormLayout title="sign up">
      <SignupForm />
    </FormLayout>
  );
};

export default SignUp;
